import React, { useRef, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BlockTitle, createNotification } from "../../../../common/components";
import { Header, UserList } from "./components";
import { ApiService, BackOfficeService } from "../../../../api";
import { translate } from "../../../../common/providers";
import { search } from "../../slice/dsi-slice";
import { useApi, usePrevious } from "../../../../common/hooks";
import { downloadFile } from "../../../../common/utils";
import { removeNullFilters } from "../../utils/utils";
import styles from "./DSIExportUser.module.css";

export default function DSIExportUser({ companies = [] }) {
	const { call: getAllProjects } = useApi(BackOfficeService.getAllProjects);
	const { call: exportUsers } = useApi(BackOfficeService.exportUsers);
	const [openExport, setOpenExport] = useState(false);
	const [projectsRequest, setProjectsRequest] = useState([]);
	const savedPage = useSelector(({ dsi }) => dsi.page);
	const savedLimit = useSelector(({ dsi }) => dsi.limit);
	const savedFilters = useSelector(({ dsi }) => dsi.filters);
	const cancelTokenSourceRef = useRef(null);
	const dispatch = useDispatch();
	useEffect(() => {
		cancelTokenSourceRef.current = ApiService.getCancelTokenSource();
		return () => {
			ApiService.cancelTokens(cancelTokenSourceRef.current);
		};
	}, []);
	useEffect(() => {
		setProjectsRequest(
			() =>
				({ page, limit, search: test }) =>
					getAllProjects({ filter: test, page, limit })
		);
	}, [getAllProjects]);
	const handleSearchUsers = useCallback(
		({ filters, page, limit, display }) => {
			dispatch(
				search({
					filters: removeNullFilters(filters),
					unfiltered: filters,
					page,
					limit,
					token: cancelTokenSourceRef.current.token,
					display,
				})
			);
		},
		[dispatch]
	);
	const prevPage = usePrevious(savedPage);
	const prevLimit = usePrevious(savedLimit);
	useEffect(() => {
		if (savedPage !== prevPage || savedLimit !== prevLimit) {
			handleSearchUsers({
				page: savedPage,
				limit: savedLimit,
				filters: savedFilters,
				display: true,
			});
		}
	}, [handleSearchUsers, savedPage, savedLimit, savedFilters, prevPage, prevLimit]);
	const handleOpenExport = () => {
		setOpenExport((prev) => !prev);
	};
	const handleExport = () => {
		exportUsers(removeNullFilters(savedFilters))
			.then(({ data, filename }) => {
				downloadFile({ data, filename, filetype: "xlsx" });
				handleOpenExport();
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				createNotification({ message: translate("dsi.dsi-export-user.success") });
			});
	};
	return (
		<>
			<div className={styles.main} translate="no">
				<BlockTitle>{translate("dsi.dsi-export-user.title")}</BlockTitle>
				<Header
					companies={companies}
					openExport={openExport}
					projectsRequest={projectsRequest}
					onExport={handleExport}
					onOpenExport={handleOpenExport}
					onSearch={handleSearchUsers}
				/>
				<div className={styles.table}>
					<UserList onSearch={handleSearchUsers} />
				</div>
			</div>
		</>
	);
}
